<template>
<div class="contentBox demandFilePage">
    <div class="pageTitle">
        <el-steps :active="1" simple finish-status="wait" style="padding-left: 0;width: 100%">
            <el-step title="编辑" icon="el-icon-edit" @click.native="jumpNavPage('/onDemand/edit')"></el-step>
            <el-step title="文件管理" icon="el-icon-files"></el-step>
            <el-step title="分享" icon="el-icon-share" @click.native="jumpNavPage('/onDemand/share')"></el-step>
            <el-step title="访问统计" icon="el-icon-data-analysis" @click.native="jumpNavPage('/onDemand/statistics')"></el-step>
        </el-steps>

    </div>
    <div class="managementBox">

        <el-table v-loading="dataLoading" :data="tableData" style="width: 100%" border ref="refTable">
            <el-table-column label="名称">
                <template slot-scope="props">
                    <div class="fileDetailItem">
                        <div class="listImgWrap">
                            <img :src="props.row.thumb" alt="" />
                            <i class="videoBtn" @click="videoDialog = true, viewVideoId = props.row.videoId"></i>
                        </div>
                        <div class="fileInfo">
                            <a href="javascript:;" class="liveName">{{ props.row.title }}</a>
                            <div class="payInfo" v-if="props.row.status === 1">
                                <span>时长：{{ props.row.duration | timeMeter}} </span>
                                <span>分辨率：{{ props.row.height }} * {{ props.row.width }}</span>
                            </div>
                            <div class="payInfo" v-else>
                                <span>时长：-</span>
                                <span>分辨率：-</span></div>
                            <div class="iconBox">
                                <div v-if="props.row.status === 1" class="icon liveIcon" @click="videoDialog = true, viewVideoId = props.row.videoId"></div>
                                <div class="icon editIcon" @click="editTitle(props.row)"></div>
                                <div class="icon downloadIcon" @click="moveBackward(props.row)"></div>
                                <div class="icon uploadIcon" @click="moveForward(props.row)"></div>
                                <el-popconfirm v-if="props.row.status === 1" title="确定要删除改视频吗？" @confirm="deleteVideo(props.row)">
                                    <div class="icon deleteIcon" slot="reference"></div>
                                </el-popconfirm>

                            </div>
                        </div>
                        <!-- <div class="transcoding">转码中</div> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="时间" width="200"></el-table-column>
            <el-table-column class="stateGreen" label="状态" width="124" align="center">
                <template slot-scope="props">
                    <div v-if="props.row.status === 1" class="statusText">正常</div>
                    <div v-if="props.row.status === 0" class="statusText statusTextGreen">转码中</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="paginationBox" v-if="tableData.length > pageSize">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="currentTotal" prev-text="上一页" next-text="下一页"></el-pagination>
    </div>
    <div class="searchBox">
        <button id="uploadVideo" class="buyBtn" @click="showUploader = true">
            <img src="../../assets/plusIcon.svg" alt />上传视频
        </button>
    </div>

<!-- 预览 -->
  <el-dialog title="预览视频" :visible.sync="videoDialog" @opened="openVideo" @close="closeVideo">
      <div class="video-tem">
          <div id="J_prismPlayer" class="prism-player"></div>
      </div>
  </el-dialog>
    <el-drawer
            title="文件上传"
            :visible.sync="showUploader"
            :wrapperClosable="false"
            :modal="false"
            size="400px"
            @close="uploaderClosed">
        <div style="padding: 20px">
        <el-upload
                class="upload-demo"
                accept=".avi, .mp4, .mpeg, .mpg, .wmv, .mkv, .flv, .mov"
                drag
                action="#"
                :auto-upload="true"
                :on-change="handleFileChange"
                :http-request="uploadFile"
                multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传视频文件，且不超过100Gb</div>
        </el-upload>
        </div>
    </el-drawer>
    <el-dialog
            title="修改名称"
            :visible.sync="editDialogVisible"
            width="480px">
        <span>
            <el-input ref="videoTitle"
                      placeholder="请输入新标题"
                      v-model="currentVideo.title">
                <i slot="prefix" class="el-input__icon el-icon-film"></i>
            </el-input>
        </span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveVideoTitle" :loading="savingTitle">确 定</el-button>
        </span>
    </el-dialog>
</div>


</template>

<script>
    import $ from "jquery";
    import common from '../../common.vue';
    import OSS from 'ali-oss';

    const GET_VIDEO_DATA_URL = common._BASE_ + 'vod/vodVideoList';
    const SAVE_VIDEO_URL = common._BASE_ + 'vod/saveVodVideo';
    const GET_VIDEO_RESOLUTION = common._BASE_ + 'vod/getVideoResolution';
    // 编辑/删除报错映射表
    const OPERATE_ERROR_MAPPER = {
        "0": "",
        "-1": "登录已过期",
        "-2": "访问被拒绝",
        "-3": "无效的视频",
        "-4": "移动失败"
    };

    export default {
        name: "DemandFileManagement",
        data() {
            return {
                vodId : -1,
                currentPage: 1,
                pageSize: 999,
                currentTotal: 0,
                tableData: [],
                uploader: {},
                quickliveSignatrue: null,
                timer: '',
                loading: '',
                aliplayerSdkPath: "https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js",
                videoDialog: false,
                viewVideoId: -1,
                video: null,
                // 是否显示文件上传的边栏
                showUploader: false,
                // oss上传配置
                ossConfig: {},
                // oss上传客户端
                ossClient: null,
                // 正在上传的文件个数
                uploadingFilesCount: 0,
                // 是否显示编辑窗口
                editDialogVisible: false,
                // 当前处理的视频
                currentVideo: {},
                // 是否正在保存标题编辑
                savingTitle: false,
                // 是否正在操作视频（向服务器发起请求）
                dataLoading: false
            };
        },
        methods: {
            initVideo(vodId) {
                let _this = this;
                if (vodId) {
                    _this.vodId = vodId;
                    _this.dataLoading = true;
                    _this.$axios.post(GET_VIDEO_DATA_URL, this.$qs.stringify({vodId: vodId})).then(function (res) {
                        _this.dataLoading = false;
                        _this.currentTotal = res.data.count;
                        _this.tableData = res.data.data;
                    });
                }
            },
            insertScriptTag() {
                const _this = this;
                let playerScriptTag = document.getElementById("playerScriptTag");
                // 如果这个tag不存在，则生成相关代码tag以加载代码
                if (playerScriptTag === null) {
                    playerScriptTag = document.createElement("script");
                    playerScriptTag.type = "text/javascript";
                    playerScriptTag.src = _this.aliplayerSdkPath;
                    playerScriptTag.id = "playerScriptTag";
                    let s = document.getElementsByTagName("head")[0];
                    s.appendChild(playerScriptTag);
                }
            },
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            setCurrentTotal() {
                this.currentTotal = this.tableData.length;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                console.log(`当前页: ${val}`);
            },
            //预览
            openVideo() {
                let _this = this;
                let data = Object.assign({videoId: _this.viewVideoId});
                _this.$axios.post(GET_VIDEO_RESOLUTION, this.$qs.stringify(data)).then(function (res) {
                    if (res.data.data) {
                        if (_this.video) {
                            _this.video.dispose();
                        }
                        $('#J_prismPlayer').empty();//id为html里指定的播放器的容器id
                        _this.video = window.Aliplayer({
                                "id": "J_prismPlayer",
                                "source": '{' +
                                    '"HD":"' + res.data.data[0].uri + '?sn=' + new Date().getTime() + '",' +
                                    '"SD":"' + res.data.data[1].uri + '?sn=' + new Date().getTime() + '"}',
                                "width": "100%",
                                "height": "500px",
                                "autoplay": true,
                                "isLive": false,
                                "rePlay": false,
                                "playsinline": true,
                                "preload": true,
                                "controlBarVisibility": "hover",
                                "useH5Prism": true
                            }, function () {
                            }
                        );
                    }
                });
            },

            // 关闭预览
            closeVideo(){
                this.video&& this.video.dispose();
            },

            // 关闭上传边栏
            uploaderClosed(){

            },
            handleFileChange(file, fileList) {
                //this.posterFile = file.raw;
                console.info(fileList);
            },
            /**
             * 编辑文件标题
             */
            editTitle(item){
                if(!item){ return; }

                this.currentVideo = item;
                this.editDialogVisible = true;
                let _this = this;
                setTimeout(function(){
                    _this.$refs.videoTitle.select();
                }, 100);
            },
            /**
             * 保存视频标题
             */
            saveVideoTitle(){
                let _this = this;
                _this.savingTitle = true;
                _this.$axios.post(common._BASE_ + '/vod/saveVideoTitle',
                    this.$qs.stringify({videoId: _this.currentVideo.videoId, title: _this.currentVideo.title})).then(function (res) {
                    _this.savingTitle = false;
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '错误',
                            message: OPERATE_ERROR_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    }else{
                        // 更新列表中录播标题
                        _this.editDialogVisible = false;
                    }
                });
            },
            /**
             * 向前移动
             */
            moveForward(video){
                let _this = this;
                _this.dataLoading = true;
                _this.$axios.post(common._BASE_ + '/vod/moveVideoForward',
                    _this.$qs.stringify({videoId: video.videoId})).then(function (res) {
                    let r = res.data;
                    _this.dataLoading = false;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '错误',
                            message: OPERATE_ERROR_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    }else{
                        _this.initVideo(_this.$route.params.id || _this.$route.query.id);
                    }
                });
            },
            /**
             * 向后移动
             */
            moveBackward(video){
                let _this = this;
                _this.dataLoading = true;
                _this.$axios.post(common._BASE_ + '/vod/moveVideoBackward',
                    _this.$qs.stringify({videoId: video.videoId})).then(function (res) {
                    _this.dataLoading = false;
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '错误',
                            message: OPERATE_ERROR_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    }else{
                        _this.initVideo(_this.$route.params.id || _this.$route.query.id);
                    }
                });
            },

            /**
             * 删除视频
             */
            deleteVideo(video){
                let _this = this;
                _this.dataLoading = true;
                _this.$axios.post(common._BASE_ + '/vod/deleteVideo',
                    _this.$qs.stringify({videoId: video.videoId})).then(function (res) {
                    _this.dataLoading = false;
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '错误',
                            message: OPERATE_ERROR_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    }else{
                        _this.initVideo(_this.$route.params.id || _this.$route.query.id);
                    }
                });
            },

            /**
             * 获取oss上传令牌
             */
            getConfig(callback){
                let _this = this;

                _this.$axios.post(common._BASE_ + 'ali/ossVideoCredential').then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        callback && callback(r);
                    }
                });
            },

            /**
             * 根据服务器上返回的授权构建oss配置
             */
            buildConfig(r){
                let _this = this;

                _this.ossConfig = Object.assign({
                    refreshSTSTokenInterval: 900*1000,
                    refreshSTSToken: async () => {
                        let res = await _this.$axios.post(common._BASE_ + 'ali/ossVideoCredential');
                        return {
                            accessKeyId: res.data.accessKeyId,
                            accessKeySecret: res.data.accessKeySecret,
                            stsToken: res.data.stsToken,
                        }
                    }
                }, r);
            },
            /**
             * 上传文件到OSS
             */
            uploadFile(params){
                let _this = this;
               console.info(params);
               if(!_this.ossClient){
                   _this.ossClient = new OSS(this.ossConfig);
               }
               let file = params.file,
                   fileName = common.guid() + "." + common.fileExt(file.name),
                   ossKey = common.assertPath(this.ossConfig.folder) + fileName,
                   checkPoint;

                _this.uploadingFilesCount++;
                _this.ossClient.multipartUpload(ossKey, file, {
                    checkPoint,
                    async progress(percentage, cpt){
                        params.onProgress({percent:Math.floor(percentage*100)});
                        checkPoint = cpt;
                    }
                }).then(function (r2) {
                    console.log('get success: %j', r2);
                    params.onSuccess(r2.res);
                    _this.uploadingFilesCount--;
                    _this.uploadSuccess(ossKey, file);
                }).catch(function (err) {
                    console.error('error: %j', err);
                    _this.uploadingFilesCount--;
                    params.onError();
                });
            },
            /**
             * oss文件上传成功回调
             */
            uploadSuccess(ossKey, file){
                let _this = this;

                _this.$axios.post(SAVE_VIDEO_URL,
                    this.$qs.stringify({
                        vodId: _this.$route.params.id, title: file.name, ossPath: ossKey})).then(function (res) {
                    let r = res.data;
                    if (r.code > -2) {
                        _this.initVideo(_this.$route.params.id);
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: file.name + '保存失败'
                        })
                    }
                });
            },

            jumpNavPage(path) {
                this.$router.push({
                    path: path + "/" + this.vodId
                });
            }
        },
        mounted() {
            let _this = this;
            _this.insertScriptTag();
            _this.initVideo(this.$route.params.id || this.$route.query.id);

            _this.getConfig(function (c) {
                _this.buildConfig(c);
            });
        },
        beforeRouteLeave(to, from, next){
            if(this.uploadingFilesCount === 0 || confirm('文件正在上传，确定要离开吗？')){
                next();
            }else{
                next(false);
            }
        },
        filters: { //钩子
            timeMeter(t) {
                let time = Number(t);
                let h = time / 3600 < 10 ? "0" + parseInt(time / 3600) : parseInt(time / 3600);
                if (h != '00') time = time - h * 3600;
                let m = time / 60 < 10 ? "0" + parseInt(time / 60) : parseInt(time / 60);
                let s = time % 60 < 10 ? "0" + (time % 60) : time % 60;
                //if (type == 1) {
                return h + ':' + m + ":" + s;
                /*} else if (type == 2) {
                  return m + "分" + s + "秒";
                }*/
            }
        },
    };
</script> 

<style lang="less">
@import 'https://g.alicdn.com/de/prismplayer/2.13.2/skins/default/aliplayer-min.css';
.demandFilePage {
    .pageTitle {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;


        .clearBtn {
            width: 80px;
            height: 40px;
            background: #076eff;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            margin-left: 10px;
        }

        .clearBtn:hover {
            background: #4aa3f8;
        }
    }

    // .managementBox{
    //     height:880px;
    // }

    .searchBox {
        position: relative;
        display: flex;
        float: left;

        .buyBtn {
            width: 137px;
            height: 40px;
            background: #076eff;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            margin-top: 16px;

            img {
                margin-right: 6px;
            }
        }

        .buyBtn:hover {
            background: #4aa3f8;
        }
    }

    .fileDetailItem {
        padding: 8px 0px 0px;
        display: flex;
        font-size: 14px;
        font-weight: 400;
        color: #a2a9ab;
        // background: #f5f6f7;
        position: relative;

        .transcoding {
            position: absolute;
            right: 43px;
            font-size: 14px;
            font-weight: 400;
            color: #59c24b;
        }

        .listImgWrap {
            width: 160px;
            height: 90px;
            border-radius: 6px;
            margin-right: 24px;
            overflow: hidden;
            position: relative;

            img {
                width: 100%;
                height: auto;
                transition: all 0.6s;
                -webkit-transition: all 0.6s;
            }

            .videoBtn {
                position: absolute;
                width: 30px;
                height: 30px;
                background: url("../../assets/playIcon.svg") no-repeat center center;
                background-size: 100% 100%;
                border-radius: 50%;
                position: absolute;
                top: 30px;
                left: 68px;
                z-index: 2;
                -webkit-transition: all 0.2s ease-out;
                -o-transition: all 0.2s ease-out;
                -moz-transition: all 0.2s ease-out;
                transition: all 0.2s ease-out;
                opacity: 0;
                -webkit-transform: scale(1.2);
                -moz-transform: scale(1.2);
                -ms-transform: scale(1.2);
                -o-transform: scale(1.2);
                transform: scale(1.2);
                cursor: pointer;
            }
        }

        .liveName {
            width: 600px;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #221816;
            margin-right: 31px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            cursor: pointer;
        }

        .liveName:hover {
            color: #306ff6;
        }

        .payInfo {
            margin-top: 6px;
            margin-bottom: 10px;

            span {
                margin-right: 30px;
            }
        }

        .iconBox {
            display: flex;

            .icon {
                width: 30px;
                height: 30px;
                margin-right: 9px;
            }

            .liveIcon {
                background: url('../../assets/manageLiveWhite.svg') 0 0 no-repeat;
            }

            .liveIcon:hover {
                background: url('../../assets/manageLiveBlue.svg') 0 0 no-repeat;
            }

            .editIcon {
                background: url('../../assets/manageEditWhite.svg') 0 0 no-repeat;
            }

            .editIcon:hover {
                background: url('../../assets/manageEditBlue.svg') 0 0 no-repeat;
            }

            .downloadIcon {
                background: url('../../assets/manageDownloadWhite.svg') 0 0 no-repeat;
            }

            .downloadIcon:hover {
                background: url('../../assets/manageDownloadBlue.svg') 0 0 no-repeat;
            }

            .uploadIcon {
                background: url('../../assets/manageUploadWhite.svg') 0 0 no-repeat;
            }

            .uploadIcon:hover {
                background: url('../../assets/manageUploadBlue.svg') 0 0 no-repeat;
            }

            .deleteIcon {
                background: url('../../assets/manageDeleteWhite.svg') 0 0 no-repeat;
            }

            .deleteIcon:hover {
                background: url('../../assets/manageDeleteBlue.svg') 0 0 no-repeat;
            }
        }
    }

    .fileDetailItem:hover {
        .listImgWrap {
            img {
                transform: scale(1.06);
                -webkit-transform: scale(1.06);
            }

            .videoBtn {
                opacity: 1;
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -ms-transform: scale(1);
                -o-transform: scale(1);
                transform: scale(1);
                cursor: pointer;
            }
        }

        .liveName {
            color: #306ff6;
        }



    }

    .statusTextGreen {
        color: #59c24b;
    }

    body .el-table th.gutter {
        display: table-cell !important;
    }

    .el-table .el-table__cell {
        padding: 13px 0;
        cursor: pointer;
    }

    .el-table th.el-table__cell>.cell {
        font-size: 14px;
        font-weight: bold;
        color: #221816;
        padding-left: 20px;
    }

    .el-table .cell,
    .el-table--border .el-table__cell:first-child .cell {
        padding: 0 20px;
        color: #221816;
    }

    .el-table__expanded-cell {
        padding: 0 !important;
    }

}

.is-center .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
</style>